import React from 'react';
import { XStack, YStack } from 'smoothie';

import type { MemberDetails } from '../../../entityTypes';
import { MemberExternalAccounts } from './MemberExternalAccounts';
import { MemberRecurringTransfers } from './MemberRecurringTransfers';

interface MembershipBankingOpsProps {
    members: MemberDetails[];
}

export const MembershipBankingOps = ({
    members,
}: MembershipBankingOpsProps) => {
    return (
        <YStack>
            <XStack justifyContent="space-between" flexWrap="wrap">
                {members.map((member) => (
                    <MemberExternalAccounts key={member.id} user={member} />
                ))}
            </XStack>
            <XStack justifyContent="space-between" flexWrap="wrap">
                {members.map((member) => (
                    <MemberRecurringTransfers
                        key={`${member.id}:transfers`}
                        user={member}
                    />
                ))}
            </XStack>
        </YStack>
    );
};
